module.exports = "/_next/static/images/game-1-phone-gallery-08-23-0715-79dfc640b0c262330b0235bd90a4a772.jpg";